
import type { PropOptions } from 'vue';
import Vue from 'vue';
import Modal from '~/components/common/Modal/Modal.vue';
import CloseIcon from '~/assets/svg/close.vue.svg';

export default Vue.extend({
  name: 'PublicPortfolioModal',
  components: { Modal, CloseIcon },
  props: {
    modalName: {
      type: String,
      required: true,
    } as PropOptions<string>,
    modalWidth: {
      type: [Number, String],
      default: 515,
    } as PropOptions<number>,
    title: {
      type: String,
      default: '',
    } as PropOptions<string>,
    closeable: {
      type: Boolean,
      default: true,
    } as PropOptions<boolean>,
    closeSilently: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    passive: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  methods: {
    handleClose() {
      if (this.passive) {
        this.$emit('before-close');
        return;
      }

      this.$modal.hide(this.modalName);
    },
  },
});
